export const DEFAULT_SEARCH_CHAR_LIMIT = 2;
export const DEFAULT_FILTERS_SEARCH_CHAR_LIMIT = 2;
